export default "__VITE_ASSET__d6c4b491__"